import logic from "src/utils/genLogic";
import { ActionTypes } from "./actions";

const apiNamespace = "visits";

const getAllVisitsLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_ALL_VISITS,
});

const getVisitWithIdLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_VISIT_WITH_ID,
});

export default [getAllVisitsLogic, getVisitWithIdLogic];
